import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { MONEY_ACCOUNT_TYPE, MoneyAccount } from 'src/features/moneyAccounts/utils/types';
import { ListDTO, ListResponseAPI } from 'src/lib/queries';
import { CURRENCY } from 'src/types';

const RESOURCE = '/tenants/money-account/';

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    type?: MONEY_ACCOUNT_TYPE[];
    is_active?: boolean;
    currency?: CURRENCY;
    billing_entity?: string;
}

const queryFn = ({ ...params }: DTO): Promise<ListResponseAPI<MoneyAccount>> => {
    return axios.get(formatResourcePath(RESOURCE), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_MONEY_ACCOUNTS_RESOURCE, useQueryHook as useListMoneyAccounts };
